module.exports = __webpack_public_path__ + "img/2B.9e891000.jpeg";